export const ImagePlaceholderSlotType = {
  Image: 'image',
  Placeholder: 'placeholder',
};

export default {
  ImagePlaceholderSlotType,
};
